"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "empty"
  }, [_c("img", {
    staticClass: "empty-img",
    attrs: {
      src: "https://qiniu.wszn.top/cdn/assets/images/in_the_planning.jpg",
      alt: "规划中，敬请期待！Planning"
    }
  })]);
}];
render._withStripped = true;